import React from "react";
var __jsx = React.createElement;
import stl from "./HeadingStepss.module.css";
import useIsWebView from "@hooks/useIsWebview";
var HeadingSteps = function HeadingSteps(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var isWebview = useIsWebView();
  if (isWebview) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " ").concat(className || "")
  }, children);
};
export default HeadingSteps;